import { render, staticRenderFns } from "./AccountGenerate.vue?vue&type=template&id=6f5b0764&scoped=true&"
import script from "./AccountGenerate.vue?vue&type=script&lang=js&"
export * from "./AccountGenerate.vue?vue&type=script&lang=js&"
import style0 from "./AccountGenerate.vue?vue&type=style&index=0&id=6f5b0764&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b0764",
  null
  
)

export default component.exports